import * as Types from './types';
import { actionTypes } from './constants';

export const startIntegration = (): Types.ILottoStartIntegrationAction => ({
    type: actionTypes.LOTTO_START
});

export const stopIntegration = (): Types.ILottoStopIntegrationAction => ({
    type: actionTypes.LOTTO_STOP
});

export const startRendering = (): Types.ILottoAppRenderStartAction => ({
    type: actionTypes.LOTTO_RENDER_START
});

export const setIntegrationScriptFetching = (): Types.ILottoSetIntegrationScriptFetchingAction => ({
    type: actionTypes.LOTTO_INTEGRATION_SCRIPT_FETCHING
});

export const setIntegrationScriptFetched = (): Types.ILottoSetIntegrationScriptFetchedAction => ({
    type: actionTypes.LOTTO_INTEGRATION_SCRIPT_FETCHED
});

export const setIntegrationScriptError = (): Types.ILottoSetIntegrationScriptErrorAction => ({
    type: actionTypes.LOTTO_INTEGRATION_SCRIPT_ERROR
});

export const setAppInitialized = (isInitialized: boolean): Types.ILottoSetAppInitializedAction => ({
    type: actionTypes.LOTTO_INITIALIZED_UPDATE,
    payload: isInitialized
});

export const setAppInitializing = (): Types.ILottoSetAppInitializingAction => ({
    type: actionTypes.LOTTO_INITIALIZING_UPDATE
});

export const setAppInitError = (): Types.ILottoSetAppInitErrorAction => ({
    type: actionTypes.LOTTO_INITIALIZE_ERROR
});
